import { RuralLocationInteractor, RuralLocationRequest, RuralLocationStructRequest} from "../../Coordinator/RuralLocation/RuralLocationInteractor";

export class RuralLocationViewModel {
    private interactor: RuralLocationInteractor;

	constructor() {
		this.interactor = new RuralLocationInteractor();
	}

    public fetchSave(obj: any): PromiseLike<any> {
        var request = new RuralLocationRequest(
            obj["sgeplocalizacaorural"] ? parseInt(obj["sgeplocalizacaorural"]) : 0,
            obj["nome"] ? obj["nome"] : ""
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res(true)
			}, e => {
				return rej(e)
			});
		})
    }

    public fetchDataOne(obj: any): PromiseLike<any> {
        var request = new RuralLocationStructRequest(
            obj["sgeplocalizacaorural"] ? parseInt(obj["sgeplocalizacaorural"]) : 0
        )
        
        return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
    }
}